const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://i36kk0k0hb.execute-api.eu-west-1.amazonaws.com/prod',
    COMPANY_API_URL: 'https://emgzqi0v31.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.eu.forwood.one'
  },
  configurationService: {
    URL: 'https://config.eu.forwood.one',
    WEBSOCKET: 'wss://njlct11lni.execute-api.eu-west-1.amazonaws.com/prod'
  },
};

export default config;